module.exports = __webpack_public_path__ + "static/media/cardDeath.5f7c6ce7.png";